import Container from "@mui/material/Container";
import ComponentList from "../component/Listinvoice";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Toolbar from "@mui/material/Toolbar";
import { useContext, useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { TextField, Typography, Collapse, Button } from "@mui/material";
import { useErrValidate } from "../utilitis/AuthorizationPage";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { RolesContext } from "../context/User";
import Alert from "@mui/material/Alert";
import CustomCard from "../styleComp/CustomCard";

export default function AllInvoice() {
  const [todate, settoDate] = useState("");
  const [fromdate, setfromDate] = useState("");
  const [ivnum, setIvnum] = useState("");
  const [type, setType] = useState("");
  const { validationPage } = useErrValidate();
  const [expanded, setExpanded] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [data, setData] = useState();
  const [stateroles, dispatchroles] = useContext(RolesContext);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const SearchData = () => {
    setClicked(true);
    setData({ todate: todate, fromdate: fromdate, type: type, ivnum: ivnum });
    // settoDate("");
    // setfromDate("");
    setIvnum("");
    setType("");
  };

  useEffect(() => {
    validationPage("getinvoice");
  }, [stateroles.userId]);

  const handleValueChange = (newValue) => {
    setClicked(newValue);
  };

  const handlefromdateChange = (event) => {
    setfromDate(event.target.value);
  };

  const handletodateChange = (event) => {
    settoDate(event.target.value);
  };

  const handletypeChange = (event) => {
    setType(event.target.value);
  };

  const handleIvnum = (event) => {
    setIvnum(event.target.value);
  };

  return (
    <Container maxWidth="100%">
      {/* ---------------------For XL desktop------------------------------------ */}
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "none", xl: "block" } }}
      >
        <CustomCard overflowCard={"scroll"}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginTop: "1rem" }}
          >
            <Typography variant="h4"> חשבוניות וקבלות</Typography>
            <Toolbar>
              <TextField
                sx={{ marginRight: "1rem" }}
                label="מספר חשבונית"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <TextField
                sx={{ marginLeft: "1rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
              <Box sx={{ minWidth: 120, marginLeft: "1rem" }}>
                <FormControl sx={{ width: "150px" }}>
                  <InputLabel sx={{ marginTop: "-9px" }} id="type-label">
                    סוג
                  </InputLabel>
                  <Select
                    size="small"
                    value={`${type}`}
                    label="type-label"
                    onChange={handletypeChange}
                  >
                    <MenuItem value="I">חשבוניות</MenuItem>
                    <MenuItem value="T">קבלות</MenuItem>
                    <MenuItem value="C">חש. זיכוי</MenuItem>
                    <MenuItem value="both">הכל</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Button
                endIcon={<SearchIcon />}
                sx={{
                  marginLeft: "3rem",
                  padding: "1rem",
                  paddingLeft: "1rem",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Toolbar>
          </Grid>
          <br />
          <ComponentList
            handleValueChange={handleValueChange}
            clicked={clicked}
            data={data}
          />
        </CustomCard>
      </Box>
      {/* ---------------------For MD desktop------------------------------------ */}
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "block", xl: "none" } }}
      >
        <CustomCard overflowCard={"scroll"}>
          <Typography variant="h4"> חשבוניות וקבלות</Typography>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{ marginTop: "0.5rem" }}
          >
            <Grid item xs={4}>
              <TextField
                label="מספר חשבונית"
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="small"
              />
            </Grid>
            <Box sx={{ minWidth: 120, marginLeft: "1rem" }}>
              <FormControl sx={{ width: "150px" }}>
                <InputLabel sx={{ marginTop: "-9px" }} id="type-label">
                  סוג
                </InputLabel>
                <Select
                  size="small"
                  value={`${type}`}
                  label="type-label"
                  onChange={handletypeChange}
                >
                  <MenuItem value="I">חשבוניות</MenuItem>
                  <MenuItem value="T">קבלות</MenuItem>
                  <MenuItem value="both">הכל</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Button
              endIcon={<SearchIcon />}
              sx={{
                marginLeft: "3rem",
                padding: "1rem",
                paddingLeft: "1rem",
              }}
              onClick={SearchData}
            >
              חיפוש
            </Button>
          </Grid>
          <br />
          <ComponentList
            handleValueChange={handleValueChange}
            clicked={clicked}
            data={data}
          />
        </CustomCard>
      </Box>
      {/* ---------------------For Phone------------------------------------ */}
      <Box
        sx={{ flexGrow: 1, display: { xs: "block", md: "none", xl: "none" } }}
      >
        <Typography variant="h4">צפייה חשבוניות וקבלות</Typography>
        <Button
          sx={{ color: "black",marginBottom: "1rem" }}
          startIcon={<ManageSearchIcon />}
          onClick={handleExpand}
          size="large"
        ></Button>
        <Collapse in={expanded}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                size="small"
                label="מ- תאריך"
                type="date"
                variant="outlined"
                value={fromdate}
                onChange={handlefromdateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                sx={{ marginTop: "0.5rem" }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                sx={{ marginTop: "0.5rem" }}
                label="עד- תאריך"
                type="date"
                variant="outlined"
                value={todate}
                onChange={handletodateChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                size="small"
                // sx={{ marginTop: "0.5rem" }}
                label="מספר חשבונית "
                type="text"
                variant="outlined"
                value={ivnum}
                onChange={handleIvnum}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl
                size="small"
                fullWidth
                sx={{ marginTop: "0.9rem", marginBottom: "1rem" }}
              >
                <InputLabel id="type-label">סוג</InputLabel>
                <Select
                  value={`${type}`}
                  label="type-label"
                  onChange={handletypeChange}
                >
                  <MenuItem value="I">חשבוניות</MenuItem>
                  <MenuItem value="T">קבלות</MenuItem>
                  <MenuItem value="C">חש. זיכוי</MenuItem>
                  <MenuItem value="both">הכל</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Button
                endIcon={<SearchIcon />}
                size="large"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "1rem",
                }}
                onClick={SearchData}
              >
                חיפוש
              </Button>
            </Grid>
          </Grid>
        </Collapse>
        <ComponentList
          handleValueChange={handleValueChange}
          clicked={clicked}
          data={data}
        />
      </Box>
    </Container>
  );
}
